export enum OrganisationNavigationLayoutTypes {
    RIGHT = 0,
    LEFT = 1
}
